module.exports = "/assets/gift-events-listing/XMAS24-banner-comparison-mobile.png?4BXC+og";